import React, { useEffect, useState } from 'react';
import { CheckCircle, AlertCircle, X, Info } from 'lucide-react';

const Toast = ({ id, message, type, onClose }) => {
  const [isClosing, setIsClosing] = useState(false);

  // Auto-dismiss logic
  useEffect(() => {
    const timer = setTimeout(() => {
      handleClose();
    }, 4000); // Disappear after 4 seconds

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsClosing(true);
    // Wait for animation to finish before unmounting
    setTimeout(() => {
      onClose(id);
    }, 300); 
  };

  // Select Icon based on type
  const renderIcon = () => {
    switch (type) {
      case 'success': return <CheckCircle size={20} />;
      case 'error':   return <AlertCircle size={20} />;
      default:        return <Info size={20} color="#3b82f6" />;
    }
  };

  return (
    <div className={`toast-notification ${type} ${isClosing ? 'closing' : ''}`}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <span className="toast-icon">
          {renderIcon()}
        </span>
        <span>{message}</span>
      </div>
      
      <button onClick={handleClose} className="toast-close">
        <X size={16} />
      </button>
    </div>
  );
};

export default Toast;